import {Author, PostOrPage, Tag} from "@tryghost/content-api";
import {debounce} from "../utils";

import {SearchManager} from "./search-manager";

const SEARCH_CONTENT_SELECTOR = '[data-theme-search-content]';
const HAS_SEARCH_RESULTS_ATTRIBUTE = 'data-theme-has-search-results';
const QUERY_FIELD_SELECTOR = 'input[data-theme-search-query]';
const RESET_BUTTON_SELECTOR = 'input[data-theme-search-reset]';
const POSTS_RESULTS_SELECTOR = '[data-theme-search-posts]';
const AUTHORS_RESULTS_SELECTOR = '[data-theme-search-authors]';
const TAGS_RESULTS_SELECTOR = '[data-theme-search-tags]';

export class SearchUI {
  constructor(private searchManager: SearchManager) {
    document.addEventListener('input', (e) => {
      if ((e.target as HTMLElement).matches(QUERY_FIELD_SELECTOR)) {
        this.debouncedHandleSearch(e);
      }
    });

    document.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).matches(RESET_BUTTON_SELECTOR)) {
        this.clearSearchResults();
      }
    });
  }

  private clearSearchResults = () => {
    const postsResults = document.querySelector(POSTS_RESULTS_SELECTOR);
    if (postsResults) {
      postsResults.innerHTML = '';
    }

    const authorsResults = document.querySelector(AUTHORS_RESULTS_SELECTOR);
    if (authorsResults) {
      authorsResults.innerHTML = '';
    }

    const tagsResults = document.querySelector(TAGS_RESULTS_SELECTOR);
    if (tagsResults) {
      tagsResults.innerHTML = '';
    }

    document.querySelector(SEARCH_CONTENT_SELECTOR)?.removeAttribute(HAS_SEARCH_RESULTS_ATTRIBUTE);
  }
    

  private handleSearch = (e: Event) => {
    const query = (e.target as HTMLInputElement).value;
    const {posts, authors, tags} = this.searchManager.search(query);
    if (query.length > 2) {
      document.querySelector(SEARCH_CONTENT_SELECTOR)?.setAttribute(HAS_SEARCH_RESULTS_ATTRIBUTE, '');
    } else {
      document.querySelector(SEARCH_CONTENT_SELECTOR)?.removeAttribute(HAS_SEARCH_RESULTS_ATTRIBUTE);
    }
    this.render(posts, this.renderPost, POSTS_RESULTS_SELECTOR);
    this.render(authors, this.renderAuthor, AUTHORS_RESULTS_SELECTOR);
    this.render(tags, this.renderTag, TAGS_RESULTS_SELECTOR);
  }

  private debouncedHandleSearch = debounce(this.handleSearch, 300);

  private render = <T>(data: T[], renderer: (data: T) => string, targetSelector: string) => {
    const $target = document.querySelector(targetSelector);
    if (!$target) return;
    $target.innerHTML = data.map(renderer).join('');
  }

  private renderPost = ({title, feature_image, feature_image_alt, url}: PostOrPage): string => {
    return `
      <a class="search__post" href="${url}">
        <img src="${feature_image}" alt="${feature_image_alt}" />
        <h2>${title}</h2>
      </a>
    `
  }

  private renderAuthor = ({url, profile_image, name}: Author) => {
    return `
    <div class="avatar">
      <a href="${url}">
        <img src="${profile_image || ''}" alt="${name}">
      </a>
      <div class="avatar__info">
        <h4>
          ${name}
        </h4>
      </div>
    </div>
    `
  }

  private renderTag = ({url, name}: Tag) => {
    return `
      <a href="${url}" class="tag" data-tag="${name}">${name}</a>
    `
  }
}
